var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotificationBubbleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 21,
    height: 21,
    rx: 10.5,
    fill: "#ED9200"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 21,
    height: 21,
    rx: 10.5,
    stroke: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.962 12.1092C12.5334 13.5522 11.1965 14.6056 9.61548 14.6056C9.17785 14.6056 8.75936 14.525 8.37311 14.3776C7.50836 15.1486 6.4936 15.125 6.4936 15.125C6.34548 15.1224 6.21273 15.0327 6.15461 14.8962C6.09686 14.7601 6.12498 14.6022 6.22585 14.4939C6.58435 14.1106 6.80823 13.7172 6.94698 13.3647C6.43435 12.7569 6.12498 11.972 6.12498 11.1155C6.12498 9.18912 7.6891 7.625 9.61548 7.625C10.154 7.625 10.6647 7.74725 11.1204 7.96588C11.5974 7.30513 12.3736 6.875 13.25 6.875C14.6986 6.875 15.875 8.05137 15.875 9.5C15.875 10.1214 15.6586 10.6929 15.2971 11.1425C15.3946 11.372 15.5446 11.6232 15.7741 11.8689C15.875 11.9772 15.9031 12.1351 15.8454 12.2712C15.7872 12.4077 15.6545 12.4974 15.5064 12.5C15.5064 12.5 14.7714 12.5184 14.1252 11.975C13.8515 12.0721 13.5571 12.125 13.25 12.125C13.1525 12.125 13.0565 12.1197 12.962 12.1092ZM12.2352 11.9214C11.891 13.0411 10.8474 13.8556 9.61548 13.8556C9.19885 13.8556 8.80398 13.7626 8.44998 13.5961C8.30298 13.5267 8.12748 13.5601 8.01648 13.679C7.8226 13.8864 7.61185 14.0319 7.41198 14.1335C7.55523 13.8747 7.65836 13.6246 7.73223 13.3944C7.77461 13.2627 7.74085 13.1184 7.64485 13.019C7.16823 12.5259 6.87498 11.8546 6.87498 11.1155C6.87498 9.60275 8.10273 8.375 9.61548 8.375C10.0287 8.375 10.421 8.4665 10.7724 8.63075C10.6771 8.903 10.625 9.1955 10.625 9.5C10.625 10.589 11.2895 11.5242 12.2352 11.9214ZM14.5107 11.1778C14.4684 11.0461 14.5021 10.9017 14.5981 10.8024C14.9244 10.4652 15.125 10.0059 15.125 9.5C15.125 8.465 14.285 7.625 13.25 7.625C12.215 7.625 11.375 8.465 11.375 9.5C11.375 10.535 12.215 11.375 13.25 11.375C13.535 11.375 13.8054 11.3112 14.0472 11.1972C14.1946 11.1279 14.3697 11.1616 14.4807 11.2805C14.5149 11.3165 14.5494 11.3502 14.5846 11.381C14.5561 11.3109 14.5317 11.2434 14.5107 11.1778Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationBubbleIcon);
export default __webpack_public_path__ + "static/media/notification-bubble-icon.71ca5c47e2f86732cc2b2bb7d4b46547.svg";
export { ForwardRef as ReactComponent };